import React from 'react';

import './LatestNews.css';

const LatestNews = () => {
  return (
    <div className="latest-news">
      <div className="container">
        <h1>Latest news</h1>
        <div className="row">
          <div className="col-12 col-xl-6">
            <div className="card mb-3" style={{ maxWidth: '540px' }}>
              <div className="row g-0">
                <div className="col-md-5 news-img" style={{ backgroundImage: "url('https://natek.eu/wp-content/uploads/2022/02/1200x630-cover-fb-new-1.jpg')" }}></div>
                <div className="col-md-7">
                  <div className="card-body">
                    <div className="badges">
                      <span className="badge">woman in tech</span>
                      <span className="badge">blog</span>
                      <span className="badge">conference</span>
                      <span className="badge">diversity</span>
                    </div>
                    <h5 className="card-title">Perspektywy Women in Tech Summit: We are a Partner!</h5>
                    <p className="card-text posted-by">by Minh Trusiak, 15 Feb 2022</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <div className="card mb-3" style={{ maxWidth: '540px' }}>
              <div className="row g-0">
                <div
                  className="col-md-5 news-img"
                  style={{
                    backgroundImage:
                      "url('https://natek.eu/wp-content/uploads/2022/02/businessman-hold-fintech-financial-technology-concept-business-investment-banking-payment-cryptocurrency-investment-digital-money-business-concept-virtual-screen.png')"
                  }}
                ></div>
                <div className="col-md-7">
                  <div className="card-body">
                    <div className="badges">
                      <span className="badge">programmin languages</span>
                      <span className="badge">fintech</span>
                      <span className="badge">banking</span>
                      <span className="badge">blog</span>
                      <span className="badge">finance</span>
                    </div>

                    <h5 className="card-title">9 Best Programming Languages for FinTech, Banking and Finance in 2022</h5>
                    <p className="card-text posted-by">by Justyna Adamiak, 9 Feb 2022</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <div className="card mb-3" style={{ maxWidth: '540px' }}>
              <div className="row g-0">
                <div className="col-md-5 news-img" style={{ backgroundImage: "url('https://natek.eu/wp-content/uploads/2022/01/IMG_4601-scaled.jpg')" }}></div>
                <div className="col-md-7">
                  <div className="card-body">
                    <div className="badges">
                      <span className="badge">sourcing</span>
                      <span className="badge">recruitment</span>
                      <span className="badge">researcher</span>
                    </div>
                    <h5 className="card-title">How to start your career in recruitment?</h5>
                    <p className="card-text posted-by">by Justyna Adamiak, 5 Jan 2022</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <div className="card mb-3" style={{ maxWidth: '540px' }}>
              <div className="row g-0">
                <div className="col-md-5 news-img" style={{ backgroundImage: "url('https://natek.eu/wp-content/uploads/2021/12/group-young-business-people-working-office-scaled.jpeg')" }}></div>
                <div className="col-md-7">
                  <div className="card-body">
                    <div className="badges">
                      <span className="badge">demand in it</span>
                      <span className="badge">job openings</span>
                      <span className="badge">2021 summary</span>
                      <span className="badge">blog</span>
                    </div>
                    <h5 className="card-title">IT Professionals wanted: companies are hiring, and the supply is still too low</h5>
                    <p className="card-text posted-by">by Justyna Adamiak, 20 Dec 2021</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-center mt-3">
            <button className="btn btn-secondary">
              Read more articles{' '}
              <span className="chev">
                <i className="bi bi-chevron-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
